import { IResponse } from "../models/base";
import { IFilterOptionProps } from "../models/interface";
import {
  FilterOptionChild,
  IFilterOptionChildProps,
} from "../models/interface/IFilterOptionProps";
import { filterOptions } from "../repositories";

export default {
  getFilterOptions: async (
    query: IFilterOptionProps,
    callback: (data: IResponse<any[]> | null, err: any) => void
  ) => {
    try {
      const rs = await filterOptions.getFilterOptions(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getFilterOptionChilds: async (
    query: IFilterOptionChildProps,
    callback: (data: IResponse<any[]> | null, err: any) => void
  ) => {
    try {
      const rs = await filterOptions.getFilterOptionChilds(query);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getFilterOptionChild: async (
    params: FilterOptionChild,
    callback: (data: IResponse<any[]> | null, err: any) => void
  ) => {
    try {
      const rs = await filterOptions.getFilterOptionChild(params);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
